(function () {
  if (window.ucCartPerformanceTuneLoaded) return;
  window.ucCartPerformanceTuneLoaded = true;

  var drawerSelector = '#halo-cart-sidebar';
  var wrapperSelector = drawerSelector + ' .previewCart-wrapper';
  var refreshTimer = null;
  var wrapTimer = null;
  var styleId = 'uc-cart-performance-tune-style';

  function addStyles() {
    if (document.getElementById(styleId)) return;
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      '.uc-sticky-atc-v2{align-items:center;background:rgba(255,250,242,.98);border-top:1px solid rgba(58,35,23,.18);bottom:0;box-shadow:0 -10px 24px rgba(23,17,13,.12);display:grid;gap:8px;grid-template-columns:minmax(0,1fr) auto minmax(118px,36vw);left:0;min-height:64px;opacity:0;padding:8px 12px calc(8px + env(safe-area-inset-bottom));pointer-events:none;position:fixed;right:0;transform:translateY(115%);transition:transform .18s ease,opacity .18s ease,visibility .18s ease;visibility:hidden;z-index:80}',
      '.uc-sticky-atc-v2.is-visible,.uc-sticky-atc-v2.uc-sticky-atc-hotfix-visible{opacity:1;pointer-events:auto;transform:translateY(0);visibility:visible}',
      '.uc-sticky-atc-v2__copy{color:#2a1b14;line-height:1.08;min-width:0}',
      '.uc-sticky-atc-v2__copy strong{display:block;font-size:13px;font-weight:900;letter-spacing:0;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap}',
      '.uc-sticky-atc-v2__copy span{color:#6c574a;display:block;font-size:11px;font-weight:700;margin-top:4px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
      '.uc-sticky-atc-v2__edit{background:transparent;border:0;color:#6f3f20;font-size:12px;font-weight:900;padding:8px 2px;text-decoration:underline;text-underline-offset:3px}',
      '.uc-sticky-atc-v2__button{background:#3a2317;border:1px solid #3a2317;border-radius:4px;color:#fffaf2;cursor:pointer;font-size:12px;font-weight:900;letter-spacing:0;min-height:44px;text-transform:uppercase;width:100%}',
      '.uc-sticky-atc-v2__button:disabled{background:#7d7068;border-color:#7d7068;cursor:not-allowed;opacity:.72}',
      'body.uc-sticky-atc-v2-visible{padding-bottom:calc(72px + env(safe-area-inset-bottom))}',
      '@media (min-width:990px){.uc-sticky-atc-v2{display:none!important}body.uc-sticky-atc-v2-visible{padding-bottom:0!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function rootUrl() {
    var root = window.routes && window.routes.root ? window.routes.root : window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function route(path) {
    return rootUrl() + String(path || '').replace(/^\//, '');
  }

  function drawer() {
    return document.querySelector(drawerSelector);
  }

  function wrapper() {
    return document.querySelector(wrapperSelector);
  }

  function cartOpen() {
    return !!(document.body && document.body.classList.contains('cart-sidebar-show'));
  }

  function showDrawerNow() {
    if (!document.body || /\/cart\/?$|\/checkout/i.test(window.location.pathname)) return;
    document.body.classList.add('cart-sidebar-show', 'uc-cart-drawer-open');
    var node = drawer();
    if (node) {
      node.classList.add('uc-cart-redo');
      node.setAttribute('aria-hidden', 'false');
    }
  }

  function scheduleRefresh(delay) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      if (typeof window.refreshCartDrawer === 'function') {
        Promise.resolve(window.refreshCartDrawer()).catch(function () {});
      } else {
        document.dispatchEvent(new CustomEvent('uc:cart:refresh', { bubbles: true }));
      }
    }, delay || 60);
  }

  function tagAddonSwatches(root) {
    (root || document).querySelectorAll('.uc-cart-addon__swatch').forEach(function (swatch) {
      swatch.setAttribute('type', 'button');
    });
  }

  function ensureDrawerHealth() {
    var node = drawer();
    var wrap = wrapper();
    if (!node || !wrap) return;
    document.body.classList.toggle('uc-cart-drawer-open', cartOpen());
    tagAddonSwatches(node);
    if (cartOpen() && !wrap.querySelector('.uc-cart-shell, .uc-cart-empty')) scheduleRefresh(40);
  }

  function wrapOpenFunction(name) {
    var original = window[name];
    if (typeof original !== 'function' || original.ucPerformanceTuned) return;
    var tuned = function () {
      showDrawerNow();
      var result = original.apply(this, arguments);
      Promise.resolve(result).catch(function () {}).then(ensureDrawerHealth);
      return result;
    };
    tuned.ucPerformanceTuned = true;
    window[name] = tuned;
  }

  function wrapOpeners() {
    wrapOpenFunction('openCartDrawer');
    wrapOpenFunction('openSliderCart');
    wrapOpenFunction('openCart');
  }

  function scheduleWrapOpeners() {
    window.clearTimeout(wrapTimer);
    wrapTimer = window.setTimeout(wrapOpeners, 30);
  }

  function cartTrigger(target) {
    if (!target || !target.closest) return null;
    return target.closest('[data-uc-floating-cart], a[href$="/cart"], a[href="/cart"], a[href*="/cart?"], [data-open-cart-sidebar], [data-cart-sidebar], [data-cart-drawer], [data-cart-toggle], [data-cart-trigger], .header__icon--cart, .cart-icon, .cart-count-bubble, .site-header__cart, .header-cart');
  }

  function handleCartIntent(event) {
    var trigger = cartTrigger(event.target);
    if (!trigger || trigger.closest(drawerSelector)) return;
    showDrawerNow();
    scheduleWrapOpeners();
    scheduleRefresh(160);
  }

  function bindObservers() {
    if (!window.MutationObserver) return;
    var node = drawer();
    if (node) {
      new MutationObserver(ensureDrawerHealth).observe(node, {
        childList: true,
        subtree: true
      });
    }
    if (document.body) {
      new MutationObserver(ensureDrawerHealth).observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  function bind() {
    addStyles();
    wrapOpeners();
    ensureDrawerHealth();
    document.addEventListener('pointerdown', handleCartIntent, true);
    document.addEventListener('click', handleCartIntent, true);
    ['uc:cart:open', 'uc:cart:updated', 'uc:cart:refresh', 'cart-update', 'cart:updated', 'cart:refresh', 'ajaxCart:updated'].forEach(function (name) {
      document.addEventListener(name, function () {
        scheduleWrapOpeners();
        window.setTimeout(ensureDrawerHealth, 80);
      });
    });
    bindObservers();
    window.setTimeout(wrapOpeners, 300);
    window.setTimeout(ensureDrawerHealth, 900);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
